import React from 'react';
import './PostingContextMenu.css';

export default function PostingContextMenu(props) {

    const x = props.x;

	const [update, setUpdate] = React.useState(Date.now());
	const [showFavoritAdd, setShowFavoritAdd] = React.useState(['d-none']);
	const [showFavoritRemove, setShowFavoritRemove] = React.useState(['d-none']);

	const postingVisible = React.useRef(1);

	x.wad[props.dialogId].init = init;

	function init(postingNo, visible, memberId) {
		postingVisible.current = visible;
		console.log('visible: ' + postingVisible.current);
		x.was.axGet('Backend/webapp.php?module=Posting&task=Favorit&tasktype=get&postingTable=postings&postingNo=' + postingNo, handleGet);
	}

	function handleGet(result) {
		if (result.data.content['status'] === 1) {
			setShowFavoritRemove('d-inline');
			setShowFavoritAdd('d-none');
		}
		else {
			setShowFavoritAdd('d-inline');
			setShowFavoritRemove('d-none');
		}
		setUpdate(Date.now());
	}

	function postingDelete(buttonText) {
		x.wad['yesno'].setTitle('Beitrag ' + buttonText + '?')
		x.wad['yesno'].onClose = handleDelete;
		x.wad['yesno'].show();

	}

	function handleDelete(answer) {
		if (typeof answer === 'undefined') {
			answer = 0;
		}
		if (answer === 1) {
			let postingNo = props.answerTo;
			x.was.axGet('/Backend/webapp.php?module=Posting&task=HidePosting&postingTable=postings&postingNo=' + postingNo, handleHide);
			x.wad[props.dialogId].hide();
			setUpdate(Date.now());
		}
	}

	function handleHide(result) {
		// x.wam.get('forumGetPostings', props.moduleId)();
		console.log(result);
		x.wam[props.moduleId].postings.load();
	}

	function favoritSet() {
		let postingNo = props.answerTo;
		x.was.axGet('/Backend/webapp.php?module=Posting&task=Favorit&tasktype=set&postingTable=postings&postingNo=' + postingNo, handleSet);

	}

	function handleSet(result) {
		if (result.data.content['status'] === 1) {
			setShowFavoritRemove('d-inline');
			setShowFavoritAdd('d-none');
		}
	}

	function favoritRemove() {
		let postingNo = props.answerTo;
		x.was.axGet('/Backend/webapp.php?module=Posting&task=Favorit&tasktype=remove&postingTable=postings&postingNo=' + postingNo, handleRemove);

	}

	function handleRemove(result) {
		if (result.data.content['status'] === 1) {
			setShowFavoritAdd('d-inline');
			setShowFavoritRemove('d-none');
		}
	}

	// "Beitrag melden" (2026-08-12, Apple-Review Guideline 1.2: UGC-Apps
	// brauchen einen expliziten Melde-Mechanismus): benachrichtigt die
	// Administratoren per Mail, siehe Backend ReportPosting.inc.
	function reportPosting() {
		const postingNo = props.answerTo;
		x.wau.yesNo('Diesen Beitrag den Administratoren melden?', (answer) => {
			if (answer !== 1) return;
			x.was.axGet('/Backend/webapp.php?module=Posting&task=ReportPosting&postingNo=' + postingNo, (result) => {
				if (result.data.returncode === 1) {
					x.wah.addHint('Der Beitrag wurde den Administratoren gemeldet.');
				}
				else {
					x.wah.addHint('Beitrag konnte nicht gemeldet werden!', false);
				}
				x.wad[props.dialogId].hide();
			});
		});
	}

	function editPosting() {
		props.editPosting();
		setUpdate(Date.now());
		x.waf.focus(props.dialogId, 'base-posting');
	}

	function postingSaveEdit() {
		props.postingSaveEdit();
		setUpdate(Date.now());	
	}	

	function postingCancelEdit() {
		props.postingCancelEdit();
		setUpdate(Date.now());	
	}

	// console.log('Render PostingContextMenu...');

	return (
		<div className='posting-context-menu '>
			<span className="d-none">{update}{props.update}</span>
			<span className="context-menu-title">{'Ausgewählter Beitrag (' + props.answerTo + '):'}</span>
			{
				((x.waf.isField(props.dialogId, 'base-posting') && x.waf.isReadOnly(props.dialogId, 'base-posting')) && (x.wad[props.dialogId].memberId === x.was.memberId || x.was.isAdmin())) 
					? 
						<i className={`bi bi-pencil context-menu-icon `} title="Diesen Beitrag bearbeiten" onClick={e => editPosting()}></i>
					:
						null
			}

			{
				(x.waf.isField(props.dialogId, 'base-posting') && !x.waf.isReadOnly(props.dialogId, 'base-posting'))
					? 
						<React.Fragment>
							{
								(x.waf.get(props.dialogId, 'base-posting') !== '') 
									?
										<i className="bi bi-check-circle context-menu-icon" title="Änderungen speichern" onClick={e => postingSaveEdit()}></i>
									:
										null
							}		
							<i className="bi bi-x-circle context-menu-icon" title="Änderungen verwerfen" onClick={e => postingCancelEdit()}></i>
						</React.Fragment>
					:
					null
			}
			<i className={`bi bi-star context-menu-icon ${showFavoritAdd}`} title="Zu Favoriten hinzufügen" onClick={e => favoritSet()}></i>
			<i className={`bi bi-star-fill context-menu-icon ${showFavoritRemove}`} title="Favorit enfernen" onClick={e => favoritRemove()}></i>
			{
				!x.was.answerAsQuote &&
				<i 	className={`bi bi-quote context-menu-icon`}
					title="Diesen Beitrag in einem neuen Thema zitieren"
					onClick={e => props.postingQuote(e, x.wad[props.dialogId].posting, x.wad[props.dialogId].postingDate, x.wad[props.dialogId].memberName)}></i>
			}
			{
				(x.was.isAdmin() && postingVisible.current)
				?
					<i className={`bi bi-trash2 context-menu-icon `} title="Löschen" onClick={e => postingDelete('löschen')}></i>
				:
					null
			}
			{
				(x.was.isAdmin() && !postingVisible.current)
				?
					<i className={`bi bi-trash2-fill context-menu-icon `} title="Wiederherstellen" onClick={e => postingDelete('wiederherstellen')}></i>
				:
					null
			}
			<i
				className="bi bi-copy context-menu-icon"
				title="Beitrag in die Zwischenablage kopieren"
				onClick={e => props.copyToClipboard(e, x.wad[props.dialogId].posting, x.wad[props.dialogId].postingDate, x.wad[props.dialogId].memberName)}>
			</i>
			{
				(x.wad[props.dialogId].memberId !== x.was.memberId) &&
				<i className="bi bi-flag context-menu-icon" title="Beitrag melden" onClick={e => reportPosting()}></i>
			}
		</div>
	)

}